import { fetch as router } from "helpers/router";
import request from "utils/request";

const fetchTeamSupporters = (campaignId, teamName) => {
  const url = router("api.v2.campaigns.teams.index", { campaign: campaignId });
  return fetch(request(url))
    .then((response) => {
      if (!response.status === 200) {
        throw new Error(response.status);
      }
      return response;
    })
    .then((res) => res.json())
    .then((json) => json.data.find((i) => i.name === teamName));
};

export default fetchTeamSupporters;

export const fetchCampaignImages = (campaignId) => {
  const url = router("api.v2.campaigns.assets.index", { campaign: campaignId });
  return fetch(request(url))
    .then((response) => {
      if (!response.status === 200) {
        throw new Error(response.status);
      }
      return response;
    })
    .then((response) => response.json())
    .then((json) => json.data);
};
